import React from "react";
import {Link} from "react-router-dom";
import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";

interface MenuItemProps {
    to: string;
    icon: React.ReactNode;
    text: string;
}
export const MenuLink = ({to, icon, text}: MenuItemProps) => {
    return (
        <MenuItem component={Link} to={to} sx={{
        color: "black",
        ":visited":{color: "black" },
        ":hover": { color: "black" },
        svg: { marginTop: "-1px" },
    }}>
        <ListItemIcon>
            {icon}
        </ListItemIcon>
        <ListItemText>
            {text}
        </ListItemText>
    </MenuItem>
    );
}
